export default __webpack_public_path__ + "static/media/ava-01.c5ff6b4f.png";